import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import StringWidget from 'components/StringWidget';
import styles from './BuyBack.css';
import { fetchBuyBackShowMoreAction } from 'actions/productBuyBackActions';
import getImageUrl from 'utils/getImageUrl';
import shallowEqual from 'utils/shallowEqual';
import RateCardTable from 'pages/ProductPage/RateCardTable/RateCardTable';
import Loader from 'components/Common/Loader/Loader';
import Error from 'components/Error/Error';
import { isInit, isLoading, isSuccess, isError } from 'utils/asyncStatusHelper';

export class BuyBackDetails extends Component {
	UNSAFE_componentWillMount() {
		const { hyperlinkUrl } = this.props;
		this.props.fetchBuyBackShowMore(hyperlinkUrl);
	}

	shouldComponentUpdate(nextProps) {
		const { productBuyBack } = this.props;
		return !shallowEqual(nextProps.productBuyBack, productBuyBack);
	}

	renderRateCardTable = rateCard => {
		if (!rateCard) return null;
		return (
			<React.Fragment>
				<RateCardTable rateCardTable={rateCard.rateCardTable} headers={rateCard.headers} />
				{rateCard.tnc && <div className={cx(styles['tnc-title'], 'row')}>{rateCard.tnc}</div>}
				{!isEmpty(rateCard.tncPoints) && (
					<div className={styles['tnc-points']}>
						{rateCard.tncPoints.map((tncPoint, i) => (
							<div key={`tnc-points-${i}`}>{tncPoint}</div>
						))}
					</div>
				)}
			</React.Fragment>
		);
	};

	renderRateCard = rateCard => {
		if (!isEmpty(rateCard.rateCardTable)) {
			return this.renderRateCardTable(rateCard);
		} else if (!isEmpty(rateCard.rateCardMap)) {
			return (
				<div className={cx(styles['ratemap-container'], 'row')}>
					<div className={cx(styles['ratemap-header'], 'row')}>
						<StringWidget strKey="returnWithin" className={cx(styles['rate-table-data'], 'col-3-12')} />
						<StringWidget strKey="buybackValue" className={cx(styles['rate-table-data'], 'col-3-12')} />
					</div>
					{Object.keys(rateCard.rateCardMap).map((key, i) => {
						return (
							<div key={i} className="row">
								<div className={cx(styles['rate-table-data'], 'col-3-12')}>{key}</div>
								<div className={cx(styles['rate-table-data'], 'col-3-12')}>{rateCard.rateCardMap[key]}</div>
							</div>
						);
					})}
				</div>
			);
		}
		return null;
	};

	render() {
		const { productBuyBack } = this.props;
		if (!productBuyBack) return null;

		const productData = get(productBuyBack, ['product'], {});
		const rateCardData = get(productBuyBack, ['rateCard'], {});
		const productImgUrl = getImageUrl(productData.imageUrl, 70, 70);
		const productVertical = get(productData, ['vertical']);
		const buyBackFaq =
			productVertical === 'mobile'
				? '/pages/buyback-guarantee-faqs'
				: `/pages/buyback-guarantee-${productVertical}-faqs`;
		const buyBackTnc =
			productVertical === 'mobile' ? '/pages/buyback-guarantee-tnc' : `/pages/buyback-guarantee-${productVertical}-tnc`;

		return (
			<div>
				{(isInit(productBuyBack) || isLoading(productBuyBack)) && (
					<div className={styles['non-success-container']}>
						<Loader />
					</div>
				)}

				{isError(productBuyBack) && (
					<div className={styles['non-success-container']}>
						<Error />
					</div>
				)}

				{isSuccess(productBuyBack) && (
					<div className={styles['buyback-modal']}>
						<div className={cx(['row'], styles['modal-header'])}>
							<StringWidget strKey="buyBackGuaranteeDetails" className="col-6-12 col" />
							<a
								href={buyBackFaq}
								target="_blank"
								rel="noopener noreferrer"
								className={cx(styles['how-link'], 'col-6-12')}
							>
								<StringWidget strKey="howBuyBackWorks" />
							</a>
						</div>
						<div className={cx(styles['outer-container'], 'row')}>
							<div className="row">
								<div className={cx(styles['img-container'], 'col-2-12')}>
									<img src={productImgUrl} />
								</div>
								<div className={cx(styles['product-details'], 'col-10-12')}>
									<div className={styles['title']}>{productData.title}</div>
									<div className={styles['subTitle']}>{productData.subTitle}</div>
									<div className={styles['finalPrice']}>
										&#8377;{get(productData, ['pricing', 'finalPrice', 'value'])}
									</div>
								</div>
							</div>
							<div className={cx(styles['description'], 'row')}>{rateCardData.popUpdescription}</div>
							{this.renderRateCard(rateCardData)}
							<div className={cx(styles['footer'], 'row')}>
								<a href={buyBackTnc} target="_blank" rel="noopener noreferrer">
									<StringWidget strKey="exchangeTnC" />
								</a>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		productBuyBack: state.productBuyBack
	};
}

const mapDispatchToProps = {
	fetchBuyBackShowMore: fetchBuyBackShowMoreAction
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyBackDetails);
